export default __webpack_public_path__ + "static/media/abld_inverted_science.52e8b55a6bff50f9cda60864da936713.svg";